import styled from 'styled-components';
import { Menu, Layout, Tabs } from 'antd';

const { Sider } = Layout;


export const StyledHomepage = styled.div`
 margin:20px;
`;
export const StyledHomepageSides = styled.div`
 margin:0px 10px;
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;
export const StyledFloatLeft = styled.div`
  float: left;
`;
export const StyledFloatRight = styled.div`
  float: right;
`;
export const StyledWrapperRight = styled.div`
  margin-left: 1%;
  width: 100%;
  padding: 20px 20px;
`;
export const StyledWrapperLeft = styled.div`
  width: 25%;
  background-color: ${props => props.backgroundColor};
`;
export const StyledMenu = styled(Menu)`
  border-right: 0;
`;
export const StyledSider = styled(Sider)`
`;

export const DrawerFooter = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px 16px 0px;
  text-align: right;
`;

export const StyledContentRight = styled.div`
  display: flex !important;
  justify-content: end !important;
`;
export const StyledTabs = styled(Tabs)`
 
`;
